import template from './partCalculator.html';
import controller from './partCalculator.controller';

export default {
  restrict: 'E',
  bindings: {
    price: '<',
    quantity: '=',
    currency: '<',
    modelTransferQuantity: '=',
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/stockList/partCalculator/partCalculator.component.js